import { recuperacaoBoxStyles } from './RecuperacaoBox.styles'

export function recuperacaoBoxIO() {
  return {
    styles: recuperacaoBoxStyles
  }
}

export type RecuperacaoBoxIO = ReturnType<typeof recuperacaoBoxIO>
